// extracted by css-extract-rspack-plugin
export default {"root":"gOUPCynygMtuUC6u","elevated":"tk_fm0IdGnwg9tcq","square":"MJEMoWuxS8kkXgGL"};